/**
 * @module infra-sk/modules/ElementSk
 * @description <h2><code>ElementSk</code></h2>
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ElementSk", {
    enumerable: true,
    get: function() {
        return ElementSk;
    }
});
const _html = require("lit/html.js");
const _upgradeProperty = require("../../../elements-sk/modules/upgradeProperty");
let ElementSk = class ElementSk extends HTMLElement {
    connectedCallback() {
        this._connected = true;
    }
    disconnectedCallback() {
        this._connected = false;
    }
    /**
   * Capture the value from the unupgraded instance and delete the property so
   * it does not shadow the custom element's own property setter.
   *
   * See this [Google Developers article]{@link
   *    https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
   *    } for more details.
   *
   * @param name Property name.
   */ _upgradeProperty(name) {
        (0, _upgradeProperty.upgradeProperty)(this, name);
    }
    /**
   * Renders the lit-html template found at this._template if not-null, but only if
   * connectedCallback has been called.
   */ _render() {
        if (this._connected && !!this._template) {
            (0, _html.render)(this._template(this), this, {
                host: this
            });
        }
    }
    /**
   * @param templateFn A function that, when applied to this component, will returns the component's
   *     lit-html template.
   */ constructor(templateFn){
        super();
        this._template = null;
        this._connected = false;
        this._template = templateFn || null;
    }
};
